"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eachComponent = void 0;
const index_1 = require("./index");
/**
 * Iterate through each component within a form.
 *
 * @param {Object} components
 *   The components to iterate.
 * @param {Function} fn
 *   The iteration function to invoke for each component.
 * @param {Boolean} includeAll
 *   Whether or not to include layout components.
 * @param {String} path
 *   The current data path of the element. Example: data.user.firstName
 * @param {Object} parent
 *   The parent object.
 */
function eachComponent(components, fn, includeAll, path = '', parent) {
    if (!components)
        return;
    components.forEach((component) => {
        if (!component) {
            return;
        }
        const info = (0, index_1.componentInfo)(component);
        let noRecurse = false;
        // Keep track of parent references.
        if (parent) {
            // Ensure we don't create infinite JSON structures.
            Object.defineProperty(component, 'parent', {
                enumerable: false,
                writable: true,
                value: JSON.parse(JSON.stringify(parent)),
            });
            Object.defineProperty(component.parent, 'parent', {
                enumerable: false,
                writable: true,
                value: parent.parent,
            });
            Object.defineProperty(component.parent, 'path', {
                enumerable: false,
                writable: true,
                value: parent.path,
            });
            delete component.parent.components;
            delete component.parent.componentMap;
            delete component.parent.columns;
            delete component.parent.rows;
        }
        const compPath = (0, index_1.componentPath)(component, path);
        if (includeAll || component.tree || !info.layout) {
            noRecurse = !!fn(component, compPath, components, parent);
        }
        if (!noRecurse) {
            if (info.hasColumns) {
                component.columns.forEach((column) => eachComponent(column.components, fn, includeAll, path, parent ? component : null));
            }
            else if (info.hasRows) {
                component.rows.forEach((row) => {
                    if (Array.isArray(row)) {
                        row.forEach((column) => eachComponent(column.components, fn, includeAll, path, parent ? component : null));
                    }
                });
            }
            else if (info.hasComps) {
                eachComponent(component.components, fn, includeAll, (0, index_1.componentFormPath)(component, path, compPath), parent ? component : null);
            }
        }
    });
}
exports.eachComponent = eachComponent;
